import React from 'react';
import PropTypes from 'prop-types';
import { useGetImages } from '../../../hooks';
import { getImageData } from '../../../utils';
import LazyImage from '../../LazyImage';
import { CAROUSEL_DEFAULT_ALT } from './constants';
const CarouselImage = ({
  imageId,
  enableLightbox,
  toggleModal,
  handleSelectedImage,
  priority
}) => {
  const {
    data,
    loading,
    error
  } = useGetImages(imageId);
  if (error) return error.message;
  const {
    url: imageUrl = '',
    data: imageData = {}
  } = data.getFile || {
    getFile: {
      url: '',
      data: {}
    }
  };
  const {
    altText
  } = getImageData({}, imageData);
  const alt = altText || CAROUSEL_DEFAULT_ALT;
  const handleEnableLightbox = () => {
    if (!enableLightbox) return;
    toggleModal();
    handleSelectedImage(imageId);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel__slide"
  }, loading ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(LazyImage, {
    src: imageUrl,
    alt: alt,
    sizeKey: "carousel",
    onClick: handleEnableLightbox,
    role: "button",
    "aria-label": "View Image",
    priority: priority
  }));
};
CarouselImage.propTypes = {
  imageId: PropTypes.string.isRequired,
  enableLightbox: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSelectedImage: PropTypes.func.isRequired,
  priority: PropTypes.bool.isRequired
};
export default CarouselImage;
//# sourceMappingURL=CarouselImage.js.map